import React, { useState,useEffect } from "react";
import Navbar from "./Navbar";
import ReactPaginate from "react-paginate";
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
function EmployeeLendingRequestsPage() {
    const ID = Cookies.get("log_id");
    const [requests,setRequests] = useState([]);
    function FetchLendingRequests() {
        axios.get(`${url.path}/fetch_lending_requests/`)
        .then((res) =>{
            if(res.data.status){
                var emp = res.data.requests;
                setRequests([])
                emp.map((e)=>{
                    setRequests((prevState)=>[
                        ...prevState, e
                    ])
                })
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    useEffect(() =>{
        FetchLendingRequests();
    }, [])
    const itemsPerPage = 3;
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(0);

    const filteredData = requests.filter((item) =>
      item.Role_Of_Employees.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const offset = currentPage * itemsPerPage;
    const currentItems = filteredData.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);

    const handlePageClick = ({ selected }) => {
      setCurrentPage(selected);
    };
    function searchTable(){
      var rows = document.querySelectorAll('#productstable tbody tr');
      var val = document.getElementById('search').value.trim().replace(/ +/g, ' ').toLowerCase();
      rows.forEach(function(row) {
        var text = row.textContent.replace(/\s+/g, ' ').toLowerCase();
        row.style.display = text.includes(val) ? '' : 'none';
      });
    }
    const [needs,setNeeds] = useState([]);
    function AllNeededRequests() {
      axios.get(`${url.path}/fetch_needed_employees_requests/`)
        .then((res) =>{
            if(res.data.status){
                var emp = res.data.requests;
                setNeeds([])
                emp.map((e)=>{
                  setNeeds((prevState)=>[
                        ...prevState, e
                    ])
                })
            }
            }).catch((err) => {
                console.log("ERROR", err);
              });
    }
    useEffect(() =>{
        AllNeededRequests();
    }, [])
    const [selectedCompany,setSelectedCompany] = useState({});
    const handleCompany = (requestId, companyId) => {
      setSelectedCompany((prev) => ({
        ...prev,
        [requestId]: companyId,
      }));
    };
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
      },
    });
    function GiveCompany(e) {
      e.preventDefault();
      const formdata = new FormData();
      Object.entries(selectedCompany).forEach(([requestId, companyId]) => {
          formdata.append('values', JSON.stringify({ requestId, companyId }));
        });
      axios.post(`${url.path}/give_company/`,formdata)
      .then((res) =>{
        if(res.data.status){
          Toast.fire({
            icon:'success',
            title:'Company Given..'
          })
          FetchLendingRequests();
        }
      }).catch((err) => {
        console.log("ERROR", err);
      });
    }
    return(
        <>
        <Navbar />
        <center>
            <h3 style={{fontSize:'20px',position:'relative',top:'10px'}}>Lending Requests</h3>
            </center>
            <div className="search-container">
                <input
                type="text"
                placeholder="Search..."
                onKeyUp={searchTable}
                className="search-input"
                id="search"
                />
            </div>
        <div className="table-container">
            
      <table className="responsive-table" id="productstable">
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Name</th>
            <th>Department</th>
            <th>Description</th>
            <th>Count</th>
            <th>Give Company</th>
            <th>Action</th>
            <th>Given Company</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((i,index) => (
            <tr key={i.id}>
              <td>{index+1}</td>
              <td>{i.Role_Of_Employees}</td>
              <td>{i.Department}</td>
              <td>{i.Description}</td>
              <td>{i.Available_Count}</td>
              <td><form>
                <select value={selectedCompany[i.id] || ''}
                onChange={(e) => handleCompany(i.id, e.target.value)}>
                  <option>--Select--</option>
                  {needs && needs.map((t) =>(
                      <option value={t.id}>{t.Requesting_Company_Name}</option>
                  ))}
                </select>
                </form></td>
                <td><button type="button" style={{width:'80px',backgroundColor:'gainsboro',color:'black',borderRadius:'5px'}} onClick={GiveCompany}>Assign</button></td>
                <td>{i.Assigned_Company_Name}</td>  
            </tr>
          ))}
        </tbody>
      </table>
      {filteredData.length > itemsPerPage && (
        <ReactPaginate
          previousLabel={"← Previous"}
          nextLabel={"Next →"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
        />
      )}
    </div>
        </>
    );
}
export default EmployeeLendingRequestsPage;